import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';
import ConviteUsuario from '../../convite/modal';
import CardConselheiro from './card/conselheiro';
import CardEquipeTecnica from './card/equipeTecnica';
import CardInterlocutor from './card/interlocutor';
import useStyles from './styles';

const GestaoUsuario = (props) => {
  const { open, onClose, conselheiros, equipeTecnica, interlocutores, onAction } = props;
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Drawer
        open={open}
        variant="persistent"
        onClose={onClose}
        anchor="right"
        classes={{
          paper: classes.paper,
        }}
      >
        <div className={classes.header} >
          <Typography style={{ fontSize: 25, color: '#5e6784', fontWeight: 500 }}>Gestão de usuários</Typography>
          <Button variant="contained" onClick={() => setModalOpen(true)} >Convidar</Button>
        </div>

        {conselheiros.length > 0 && (
          <div>
            <Typography className={classes.subtitulo}>Conselheiros</Typography>
            {conselheiros.map((conselheiro) => <CardConselheiro key={conselheiro.id} conselheiro={conselheiro} onAction={onAction} />)}
          </div>
        )}

        {equipeTecnica.length > 0 && (
          <div>
            <Typography className={classes.subtitulo}>Equipe Técnica</Typography>
            {equipeTecnica.map((equipe) => <CardEquipeTecnica key={equipe.id} equipe={equipe} onAction={onAction} />)}
          </div>
        )}

        {interlocutores.length > 0 && (
          <div>
            <Typography className={classes.subtitulo}>Interlocutores</Typography>
            {interlocutores.map((interlocutor) => <CardInterlocutor key={interlocutor.id} interlocutor={interlocutor} onAction={onAction} />)}
          </div>
        )}

      </Drawer>
      <ConviteUsuario open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  )
};

export default GestaoUsuario;
